import { Form } from "antd/es";
import { useContext } from "react";
import { MasterFormContext } from "../../routes/master-screen-wrapper";

export const withForm = <T extends {} = any>(Component: any) => {
  return (props: any) => {
    const [localForm] = Form.useForm<T>();
    const { form: masterForm } = useContext(MasterFormContext);
    const form = masterForm ?? localForm;
    return <Component {...props} form={form} />;
  };
};
